<section class="page">
  <div class="page__header">
    <h1>Emails</h1>
    <spw-button variant="primary" [disabled]="isSaving || !selectedType" (click)="saveTemplate()">
      {{ isSaving ? 'Enregistrement...' : 'Enregistrer' }}
    </spw-button>
  </div>

  <spw-message
    *ngIf="successMessage"
    [messageTitle]="'Succès'"
    variant="success"
    [isDismissable]="true"
    [dismissableText]="'Fermer'"
  >
    {{ successMessage }}
  </spw-message>
  <spw-message
    *ngIf="errorMessage"
    [messageTitle]="'Erreur'"
    variant="alert"
    [isDismissable]="true"
    [dismissableText]="'Fermer'"
  >
    {{ errorMessage }}
  </spw-message>

  <div class="form-field">
    <spw-field-label label="Type d'email"></spw-field-label>
    <select [(ngModel)]="selectedType" (change)="updateContentFromSelection()" [disabled]="isLoading" class="native-select">
      <option *ngFor="let template of templates" [ngValue]="template.type">
        {{ templateLabels[template.type] || template.type }}
      </option>
    </select>
  </div>

  <spw-textarea label="Contenu" name="templateContent" [value]="templateContent" (valueChanged)="onContentChanged($event.detail)" show-hint-icon="false"></spw-textarea>

  <p class="hint">
    Variables disponibles :
    <code>{{ '{{prenom}}' }}</code>,
    <code>{{ '{{buyerPrenom}}' }}</code>,
    <code>{{ '{{buyerNom}}' }}</code>,
    <code>{{ '{{plateauCode}}' }}</code>,
    <code>{{ '{{appUrl}}' }}</code>.
  </p>

  <p class="empty" *ngIf="!isLoading && templates.length === 0">Aucun template disponible.</p>
</section>
